import React from "react";
import { withStyles } from "material-ui/styles";
import grey from "material-ui/colors/grey";
import classnames from "classnames";

const styles = {
  th: {
    backgroundColor: grey[50],
    color: grey[700],
    padding: "10px 0",
    border: "1px solid #e0e0e0"
  }
};

const CHeadCell = props => {
  const { children, classes, className, ...headerCellProps } = props;
  return (
    <th {...headerCellProps} className={classnames(classes.th, className)}>
      {children}
    </th>
  );
};

export default withStyles(styles)(CHeadCell);



// WEBPACK FOOTER //
// ./src/uis/CTable/CHeadCell.jsx